<template>
  <action-dispatcher
    action="product/getProduct"
    ref="getProductDispatcher"
    :parameters="$route.params.id"
    @success="afterLoad"
  >
    <div class="checkout-header">
      <snow-steps v-model="currentStep" :steps="steps" />
      <div class="d-flex gap-2">
        <snow-button
          variant="gray"
          @click="backStep"
          :text="currentStep === 1 ? 'Cancelar' : 'Voltar'"
        />
        <snow-button
          @click="currentStep === steps.length ? onSubmit() : nextStep()"
          :disabled="!stepIsValid"
          :text="currentStep === steps.length ? 'Salvar' : 'Próximo'"
        />
      </div>
    </div>
    <div class="bg-2 p-6 rounded-16">
      <selling-data
        v-if="currentStep === 1"
        @hook:mounted="stepIsValid = true"
        :form="form"
        :errors="errors"
      />
      <payment-options
        v-if="currentStep === 2"
        @isValid="stepIsValid = $event"
        :form="form"
        :errors="errors"
      />
      <form-buy
        v-if="currentStep === 3"
        :optionForm="form.option_form"
        @update="form.option_form = $event"
        @hook:mounted="stepIsValid = true"
      />

      <checkout-layout
        v-if="currentStep === 4"
        :product="product"
        @hook:mounted="stepIsValid = true"
      />

      <support-options
        v-if="currentStep === 5"
        @save="saveSupport"
        @remove="removeSupport"
        @isValid="stepIsValid = $event"
        :product-id="$route.params.id"
        :form="form"
        :errors="errors"
      />
      <thanks-page
        v-if="currentStep === 6"
        :loading="loading"
        :form="form"
        :errors="errors"
      />
    </div>
  </action-dispatcher>
</template>

<script>
import CheckoutLayout from "@/components/product/checkout/CheckoutLayout.vue";
import FormBuy from "@/components/product/checkout/FormBuy";
import PaymentOptions from "@/components/product/checkout/PaymentOptions";
import SellingData from "@/components/product/checkout/SellingData";
import SupportOptions from "@/components/product/checkout/SupportOptions";
import ThanksPage from "@/components/product/checkout/ThanksPage";
import { formFields } from "@/functions/helpers.js";
import EditProductMixin from "@/mixins/editProduct.js";
import { mapState } from "vuex";

export default {
  mixins: [EditProductMixin],
  components: {
    SellingData,
    PaymentOptions,
    FormBuy,
    CheckoutLayout,
    SupportOptions,
    ThanksPage
  },
  data() {
    return {
      ...formFields(
        [
          "status",
          "email_support",
          "statement_descriptor",
          "expire_billet",
          "order_installment",
          "is_tax_to_producer",
          "payment_methods_ids",
          "allow_week_billet",
          "option_form",
          "option_support",
          "url_redirect",
          "url_redirect_waiting",
          "url_redirect_credit_analysis",
          "has_redirect_pix"
        ],
        {
          payment_methods_ids: []
        }
      ),
      steps: [
        "Dados da venda",
        "Opções de pagamento",
        "Formulário de compra",
        "Modelo de checkout",
        "Suporte",
        "Página de Obrigado"
      ],
      currentStep: 1,
      stepIsValid: false
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        { title: "Configurar Checkout" }
      ];
    }
  },
  methods: {
    submitSuccess() {
      this.$message.success("Alterações salvas");
      const targetRoute = {
        name: "product-details",
        params: { id: this.product.id }
      };
      const currentRoute = this.$route.name;

      if (currentRoute !== "product-details") {
        this.$router.push(targetRoute).catch(err => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
      }
    },
    saveSupport(data) {
      this.form.option_support.push(data);
    },
    removeSupport() {
      this.form.option_support = [];
    },
    onSubmitError(error) {
      const stepFields = {
        1: ["status", "email_support", "statement_descriptor"],
        2: [
          "payment_methods_ids",
          "expire_billet",
          "allow_week_billet",
          "order_installment"
        ],
        3: ["option_form"],
        4: [], // Step 4 é apenas visual (CheckoutLayout)
        5: ["option_support"],
        6: [
          "url_redirect",
          "url_redirect_waiting",
          "url_redirect_credit_analysis"
        ]
      };
      for (let e in error) {
        for (let f in stepFields) {
          if (stepFields[f].includes(e) && this.currentStep > parseInt(f)) {
            this.currentStep = parseInt(f);
            break;
          }
        }
      }
    },
    afterLoad() {
      this.form = this.product;
      if (!this.form.whatsapp_support) {
        this.form.whatsapp_support = {
          status: "inactive",
          text: "",
          number: "",
          ddi: ""
        };
      }
      this.form.payment_methods_ids = this.product.payment_methods.map(
        p => p.id
      );
      if (!this.form.allow_week_billet) {
        this.$set(this.form, "allow_week_billet", { week: [] });
      } else if (!this.form.allow_week_billet.week) {
        this.$set(this.form.allow_week_billet, "week", []);
      }
    },
    nextStep() {
      this.currentStep++;
    },
    backStep() {
      this.currentStep--;
      if (this.currentStep < 1) {
        this.$router.go(-1);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .checkout-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  gap: 16px;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    button {
      width: 100%;
      margin-top: 16px;
    }
  }
}
</style>
